export const ATTENDANCE_STATUS = {
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
  PENDING: 'pending',
};

export const ATTENDANCE_SOURCE = {
  GOOGLE_CALENDAR: 'google_calendar',
  WHATSAPP: 'whatsapp',
};

const STATUS_LABELS = {
  [ATTENDANCE_STATUS.ACCEPTED]: 'Aceptó',
  [ATTENDANCE_STATUS.DECLINED]: 'Rechazó',
  [ATTENDANCE_STATUS.PENDING]: 'Pendiente',
};

const STATUS_DESCRIPTIONS = {
  [ATTENDANCE_STATUS.ACCEPTED]: 'Asistencia aceptada',
  [ATTENDANCE_STATUS.DECLINED]: 'Asistencia rechazada',
  [ATTENDANCE_STATUS.PENDING]: 'Asistencia pendiente',
};

const SOURCE_LABELS = {
  [ATTENDANCE_SOURCE.GOOGLE_CALENDAR]: 'Google Calendar',
  [ATTENDANCE_SOURCE.WHATSAPP]: 'WhatsApp',
};

const VALID_STATUSES = Object.values(ATTENDANCE_STATUS);
const VALID_SOURCES = Object.values(ATTENDANCE_SOURCE);

const normalizeValue = (value) =>
  typeof value === 'string' ? value.trim().toLowerCase() : null;

const isLegacyConfirmed = (confirmed) =>
  confirmed === true || confirmed === 1 || confirmed === 'true';

export const getAttendanceDetails = (user) => {
  const normalizedStatus = normalizeValue(user?.attendanceStatus);
  const hasUnifiedStatus = VALID_STATUSES.includes(normalizedStatus);
  const legacyConfirmed = isLegacyConfirmed(user?.confirmed);
  const status = hasUnifiedStatus
    ? normalizedStatus
    : legacyConfirmed
    ? ATTENDANCE_STATUS.ACCEPTED
    : ATTENDANCE_STATUS.PENDING;

  const normalizedSource = normalizeValue(user?.attendanceSource);
  const source =
    status === ATTENDANCE_STATUS.PENDING
      ? null
      : VALID_SOURCES.includes(normalizedSource)
      ? normalizedSource
      : !hasUnifiedStatus && legacyConfirmed
      ? ATTENDANCE_SOURCE.WHATSAPP
      : null;
  const sourceLabel = source ? SOURCE_LABELS[source] : null;

  return {
    status,
    statusLabel: STATUS_LABELS[status],
    source,
    sourceLabel,
    tooltip: `${STATUS_DESCRIPTIONS[status]}${
      sourceLabel ? ` vía ${sourceLabel}` : ''
    }`,
  };
};
